import { type FunctionComponent } from 'react';
import { generateCloudinaryUrl } from '../../../helpers/cloudinary-helper/cloudinary-helper';
import type { PromoBannerVariationOptions } from '../../../types/promo-banner.types';
import { StyledButton } from '../../buttons';
import { CloudinaryImage } from '../../images/cloudinary-image/cloudinary-image.component';
import { BannerImage } from '../banner-image/banner-image.component';
import { DoorMarker } from '../promo-helpers/door-marker.component';
import { defaultCouponExpirationString } from '../promo-helpers/promo-banner.helpers';

export const PromoBannerA: FunctionComponent<PromoBannerVariationOptions> = ({
	headline,
	subHeading,
	couponCode,
	expirationDate,
	action,
	image,
	imageShade,
	imageOverlay
}) => {
	const backgroundUrl = generateCloudinaryUrl(image.id, {
		width: 600,
		height: undefined,
		gravity: 'custom',
		zoom: '0.9',
		crop: 'thumb'
	});
	return (
		<div className="ba b--theme-grey-light flex-ns justify-between">
			<div className="bb-ns b--theme-grey bw2 bg-theme-white pv2 pv3-ns ph3 w-50-m w-40-l">
				<div className="b f4 f3-ns theme-primary lh-title">{headline}</div>
				<div className="mt2 f6 f5-ns theme-grey-darker lh-title">{subHeading}</div>
				{(couponCode || expirationDate) && (
					<div className="f7 f5-ns mt2 theme-grey-darker">
						<DoorMarker />
						<span className="nowrap">{defaultCouponExpirationString(couponCode, expirationDate)}</span>
					</div>
				)}
				{action && (
					<div className="dn db-ns mt3-ns">
						{' '}
						<StyledButton testId="banner-cta-button">{action.name}</StyledButton>
					</div>
				)}
			</div>
			<BannerImage className="cover min-h4 relative w-50-m w-60-l" backgroundUrl={backgroundUrl} imageShade={imageShade}>
				{imageOverlay && (
					<CloudinaryImage
						publicID={imageOverlay.id}
						description="promo-a"
						className="absolute bottom-0-ns left-0 left-auto-ns max-h-100 mw-50 pa3 right-0-ns top-0 top-auto-ns"
						options={{ width: 200, height: undefined, crop: 'lfill', gravity: 'custom', preserveTransparency: true }}
						useDimensions={false}
					/>
				)}
				<div className="absolute bottom-0 dn-ns pa3 right-0 theme-white">{action?.name || ''}</div>
			</BannerImage>
		</div>
	);
};
